<template>
    <div>
        <!-- 标题 -->
        <div class="BillingPage-title">
            <Row>
                <Col span="12">
                    <Breadcrumb>
                        <BreadcrumbItem>{{$t('Bill.SLBilling.title')}}</BreadcrumbItem>
                    </Breadcrumb>
                </Col>
                <div v-show="companyIdShow==1">
                    <Col span="12">
                        <!--按账户筛选  -->
                        <Select v-model="accountSearchKey" filterable multiple :max-tag-count="1" placeholder="" @on-change="changeAccountId(accountSearchKey)" :transfer="true" style="width: 300px;float: right;margin-top: -7px;">
                            <Checkbox v-model="singleAccount" @on-change="selectAccountAll" style="display: block;text-align:right;">{{$t('Bill.Billing.selectAll')}}</Checkbox>
                            <Option :value="item.id" v-for="item in accountList" :key="item.id">{{item.name}}</Option>
                        </Select>

                        <Select v-model="companyIds" @on-change="companyIdChange" placeholder="" style="width: 200px;float: right;margin-top: -7px;margin-right: 10px;">
                            <Option v-for="item in companyIdList" :value="item.id" :key="item.id">{{ item.companyName}}</Option>
                        </Select>
                    </Col>
                </div>
            </Row>
        </div>
        <div class="BillingPage-main">
            <!--图表 -->
            <Row :gutter="16" style="height: 28%;margin-bottom: 10px;background-color: #fff;">
                <Col span="12" style="height: 100%;">
                    <Row style="width: 100%;height: 100%;" >
                        <Col span="12" style="height: 100%;">
                            <Col span="24" class="title">{{thisMonth}}{{$t('Bill.SLBilling.monthPrediction')}}</Col>
                            <Col span="24" style="text-align: center;font-size: 56px;line-height: 120px;">{{forecastCostMonth}}K</Col>
                        </Col>
                        <Col span="12" style="height: 100%;">
                            <Col span="24" class="title">{{thisMonth}}{{$t('Bill.SLBilling.monthBilling')}}</Col>
                            <Col span="24" style="text-align: center;font-size: 56px;line-height: 120px;">{{takeThisMonth}}K</Col>
                        </Col>
                    </Row>
                </Col>
                <!-- 柱状图 -->
                <Col span="12" style="height: 100%;">
                    <Row>
                        <Col span="24" class="title">{{$t('Bill.SLBilling.monthlyBillingAmount')}}</Col>
                    </Row>
                    <div id="bar" style="width:100%;height: 77%;"></div>
                </Col>
            </Row>

            <Row :gutter="16" style="background-color: #fff;height: 39%;">
                <!-- 账单概览 -->
                <Col span="12" style="height: 100%;">
                    <Row>
                        <Col span="9" class="title">{{$t('Bill.SLBilling.billingOverview')}}</Col>
                        <!-- 标签 -->
                        <Col style="width:100px;float:right;">
                            <Select v-model="tagSearch" @on-change="tagChange(tagSearch)" :placeholder="$t('Bill.ebilling.tag')">
                                <Option v-for="item in tagList" :value="item.name" :key="item.name">{{ item.name}}</Option>
                            </Select>
                        </Col>
                    </Row>
                    <div id="pieBillingOverview" style="width:100%;height: 85%;"></div>
                </Col>

                <Col span="12" style="height: 100%;">
                    <Row :gutter="16" style="width: 100%;height: 100%;">
                        <!-- Top 5 Billing by Tag -->
                        <Col span="12"  style="height: 100%;">
                            <Row>
                                <Col span="24" class="title">Top 5 Billing by Tag</Col>
                            </Row>
                            <div id="barBilling" style="width:100%;height: 90%;"></div>
                        </Col>
                        <!-- Top 3 Variance -->
                        <Col span="12" style="height: 100%;">
                            <Row>
                                <Col span="10" class="title">Top 3 Variance</Col>
                                <!-- 标签 -->
                                <Col style="width:100px;float:right;">
                                    <Select v-model="billingVarianceTag" @on-change="billingVarianceTagChange(billingVarianceTag)" :placeholder="$t('Bill.ebilling.tag')">
                                        <Option v-for="item in tagList" :value="item.name" :key="item.name">{{ item.name}}</Option>
                                    </Select>
                                </Col>
                            </Row>
                            <div id="barVariance" style="width:100%;height:90%;"></div>
                        </Col>
                    </Row>
                </Col>
            </Row>


            <!--图表 -->
            <Row :gutter="16" style="background-color:#fff;position: absolute;bottom:0px;left:0px;right:0px;height: 30%;">
                <!-- 表格 -->
                <Col span="10" style="height: 100%;">
                    <Table :no-data-text="$t('common.noData')" class="table-css" :columns="tagColumns" :data="tagData" style="width: 100.1%;height: 100%;"></Table>
                </Col>
                <Col span="2" style="height: 100%;">
                    <a class="title" @click="varianceDetail">{{ $t('alarms.common.details') }}</a>
                </Col>
                <!-- Top 15 资源类别 -->
                <Col span="12" style="height: 100%;">
                    <div class="title">{{ $t('Bill.SLBilling.resourceCategories') }}</div>
                    <div id="barResource" style="width:100%;height: 90%;"></div>
                </Col>
            </Row>
            <!-- 详情 -->
            <Modal v-model="varianceModel" title="Variance Detail" :mask-closable="false" width="800px">
                <Select v-model="ownerSearchKey" placeholder="owner" style="width: 150px;float: left;margin-top: -7px;margin-bottom: 10px;">
                    <Option v-for="item in varianceList" :value="item.id" v-bind:key="item.id">{{ item.name }}</Option>
                </Select>
                <tree-grid :items='varianceDate' :columns='varianceColumns'></tree-grid>
                <div slot="footer">
                    <Button type="text" size="large" @click="varianceCaseReset">{{ $t('alarms.common.cancel') }}</Button>
                </div>
            </Modal>
        </div>
    </div>
</template>

<script>
    var SLBillingPageVue = {};
    import {setCookie,getCookie} from '../../../utils/cookieUtil.js'
    import TreeGrid from '../sl_billing_page/TableGrid'
    export default {
        name: 'SlBillingPage',
        components: {
            TreeGrid
        },
        data () {
            return {
                companyIdShow:getCookie(global.companyId),
                companyIds:'',
                accountIdSearchKey:'',
                accountIds:[],
                accountSearchKey:[],
                companyIdList:[], // 公司
                accountIdList:[],
                accountList:[],
                singleAccount:false,
                forecastCostMonth:'',
                takeThisMonth:'',
                thisMonth:'', //本份预测本份账单
                recentOctoberBill:[],
                dateTen:[], //每月账单金额
                tagSearch:'',
                tagList:[], //标签
                overviewBills:[],
                monthCostAndVariance:[],
                newOverviewBillsList:[], // 账单概览
                resourceType:[], //账单金额
                top5Tag:[],
                top5TagCost:[],
                selected:{},
                top3TagNegativeNumber:[],
                top3TagPositiveNumber:[],
                top3Tag:[],
                billingVarianceTag:'', //Top 5 Billing by Tag&Top 3 Variance
                tagColumnsDate:[],
                ownerSearchKey:'',
                varianceModel:false,
                varianceList:[{
                    id:0,
                    name:'Alan Zheng'
                },{
                    id:1,
                    name:'Bluer Xiao'
                },{
                    id:2,
                    name:'Charles Xu'
                },{
                    id:3,
                    name:'Derek Feng'
                },{
                    id:4,
                    name:'Jeremy Zhou'
                },{
                    id:5,
                    name:'Judy Zhou'
                },{
                    id:6,
                    name:'Steven Dai'
                }],
                chartBars:'',
                chartPieBillingOverview:'',
                chartBarBilling:'',
                chartbarVariance:'',
                chartResource:'',
                tagColumns: [],
                tagData:[],
                varianceColumns: [],
                varianceDate: []
            }
        },
        beforeCreate: function() {
            SLBillingPageVue=this;
        },
        mounted:function(){
             // 自适应不同屏幕尺寸
            const self=this;
            window.addEventListener("resize",function(){
                self.chartBars.resize();
                self.chartPieBillingOverview.resize();
                self.chartBarBilling.resize();
                self.chartbarVariance.resize();
                self.chartResource.resize();
            });
            this.listRegisterInformation();
            this.getAWSAccountByCompanyId();

        },
        created(){
            this.$nextTick(function() {
                SLBillingPageVue.tagBox();
                SLBillingPageVue.billThisMonthAndBillLastMonth();
                SLBillingPageVue.monthlyBillAmount();
                SLBillingPageVue.overviewBillDate();
                SLBillingPageVue.tagTwoMonthVarianceDetails();
                SLBillingPageVue.to15ResourceCategories();
                SLBillingPageVue.toCompare();
            });
        },
        methods: {
            /******************详情*******************************************************/
            listRegisterInformation: function () {
                this.$api.user.listRegisterInformation()
                .then(res => {
                    // 获取公司列表数据
                    this.companyIdList = res.data.companies;
                    if(this.companyIdList){
                        this.companyIds=this.companyIdList[0].id;
                    }
                    this.accountSearchKey=[];
                    this.getAWSAccountByCompanyId();
                })
            },

            getAWSAccountByCompanyId: function () {
                this.$api.account.getAWSAccountByCompanyId("companyId",getCookie(global.companyId)==1? this.companyIds:getCookie(global.companyId))
                .then(res => {
                    this.accountList = res.data;
                    //默认账户全选
                    if(this.accountList){
                        for(var i=0;i<this.accountList.length;i++){
                            this.accountSearchKey.push(this.accountList[i].id);
                        }
                    }
                })
            },

            // 切换公司
            companyIdChange:function(){
                this.$echarts.init(document.getElementById("bar")).clear();
                this.$echarts.init(document.getElementById("pieBillingOverview")).clear();
                this.$echarts.init(document.getElementById("barBilling")).clear();
                this.$echarts.init(document.getElementById("barVariance")).clear();
                this.$echarts.init(document.getElementById("barResource")).clear();
                this.accountSearchKey=[];
                this.getAWSAccountByCompanyId();

                setTimeout(()=> {
                    SLBillingPageVue.tagBox();
                    SLBillingPageVue.billThisMonthAndBillLastMonth();
                    SLBillingPageVue.monthlyBillAmount();
                    SLBillingPageVue.overviewBillDate();
                    SLBillingPageVue.tagTwoMonthVariance();
                    SLBillingPageVue.tagTwoMonthVarianceDetails();
                    SLBillingPageVue.to15ResourceCategories();
                    SLBillingPageVue.toCompare();
                })
            },
            // 切换账户
            changeAccountId:function(val){
                if (val.length === this.accountList.length&&val.length!=0) {
                    this.singleAccount = true
                } else {
                    this.singleAccount = false
                }
                this.$echarts.init(document.getElementById("bar")).clear();
                this.$echarts.init(document.getElementById("pieBillingOverview")).clear();
                this.$echarts.init(document.getElementById("barBilling")).clear();
                this.$echarts.init(document.getElementById("barVariance")).clear();
                this.$echarts.init(document.getElementById("barResource")).clear();
                setTimeout(()=> {
                    SLBillingPageVue.tagBox();
                    SLBillingPageVue.billThisMonthAndBillLastMonth();
                    SLBillingPageVue.monthlyBillAmount();
                    SLBillingPageVue.overviewBillDate();
                    SLBillingPageVue.tagTwoMonthVariance();
                    SLBillingPageVue.tagTwoMonthVarianceDetails();
                    SLBillingPageVue.to15ResourceCategories();
                    SLBillingPageVue.toCompare();
                })
            },
            selectAccountAll(){
                this.accountSearchKey = []
                if (this.singleAccount) {
                    this.accountList.map((item) => {
                        this.accountSearchKey.push(item.id)
                    })
                } else {
                    this.accountSearchKey = []
                }
            },
            // 详情
            varianceDetail:function(){
                this.varianceModel=true;
                SLBillingPageVue.tagTwoMonthVarianceDetails();

            },
            // 取消
            varianceCaseReset:function(){
                this.varianceModel=false;
            },
            /******************所有图表*******************************************************/
            init:function(){
                this.$nextTick(function() {
                    SLBillingPageVue.barLine();
                    SLBillingPageVue.pieBillingOverviewLine();
                    SLBillingPageVue.barBillingLine();
                    SLBillingPageVue.barVarianceLine();
                    SLBillingPageVue.barResourceLine();
                });
            },
            /********************************************/
            // 本份预测本份账单
            billThisMonthAndBillLastMonth:function(){
                this.$api.silverliningEBilling.billThisMonthAndBillLastMonth({
                    "companyId":getCookie(global.companyId)==1? this.companyIds:getCookie(global.companyId),
                    "accountIds":this.accountSearchKey
                })
                .then(res => {
                    // 预测
                    this.forecastCostMonth=res.data.forecastCostMonth;
                    // 账单
                    this.takeThisMonth=res.data.takeThisMonth;
                    // 当前月份
                    this.thisMonth=res.data.thisMonth;
                })
            },
            /********************************************/
            // 每月账单金额
            monthlyBillAmount:function(){
                this.recentOctoberBill=[];
                this.dateTen=[];
                this.$api.silverliningEBilling.monthlyBillAmount({
                    "companyId":getCookie(global.companyId)==1? this.companyIds:getCookie(global.companyId),
                    "accountIds":this.accountSearchKey
                })
                .then(res => {
                    if(res.data.recentOctoberBill==undefined||res.data.dateTen==undefined){
                        return;
                    }
                    // 账单金额
                    this.recentOctoberBill=res.data.recentOctoberBill;
                    // x轴
                    this.dateTen=res.data.dateTen;
                    SLBillingPageVue.init();
                })
            },
            /********************************************/
            // 账单概览
            overviewBillDate:function(){
                this.overviewBills=[];
                this.selected=[];
                this.$api.silverliningEBilling.overviewBill({
                    "name":this.tagSearch,
                    "companyId":getCookie(global.companyId)==1? this.companyIds:getCookie(global.companyId),
                    "accountIds":this.accountSearchKey
                })
                .then(res => {
                    if(res.data.overviewBill==undefined||res.data.selected==undefined){
                        return;
                    }
                    this.overviewBills=res.data.overviewBill;
                    this.selected=res.data.selected;
                    this.newOverviewBillsList=[];
                    for(var i=0;i<this.overviewBills.length;i++){
                        var OverviewBillsCopy = new Object();
                        OverviewBillsCopy.name = this.overviewBills[i].name;
                        this.newOverviewBillsList.push(OverviewBillsCopy);
                    }
                    SLBillingPageVue.init();
                })
            },
            /********************************************/
            // 标签
            tagBox:function(){
                this.$api.silverliningEBilling.tagBox({})
                .then(res => {
                    // 标签列表
                    this.tagList=res.data.toCompareBox;
                    this.tagSearch=this.tagList[0].id;
                    this.billingVarianceTag=this.tagList[0].id;
                })
            },
            // 切换标签
            tagChange:function(){
                SLBillingPageVue.overviewBillDate();
            },
            /********************************************/
            // 标签两月对比
            tagTwoMonthVariance:function(){
                this.tagColumnsDate=[];
                this.tagColumns=[];
                this.$api.silverliningEBilling.tagTwoMonthVariance({
                    "companyId":getCookie(global.companyId)==1? this.companyIds:getCookie(global.companyId),
                    "accountIds":this.accountSearchKey
                })
                .then(res => {
                    if(res.data.tagColumns==undefined||res.data.monthCostAndVariance==undefined){
                        return;
                    }
                    // 标题
                    this.tagColumnsDate=[];
                    this.tagColumns=[];
                    this.tagColumnsDate=res.data.tagColumns;
                    if(this.tagColumnsDate.length>0){
                        for(var i=0;i<this.tagColumnsDate.length;i++){
                          this.tagColumns.push({
                                title:this.tagColumnsDate[i],
                                key:i
                            });
                        }
                    }

                    // 内容
                    this.monthCostAndVariance=res.data.monthCostAndVariance;
                    if(this.monthCostAndVariance.length>0){
                        this.tagData=[];
                        for(var i=0;i<this.monthCostAndVariance.length;i++){
                            this.tagData.push({
                                0:this.monthCostAndVariance[i].monthCostAndVariance[0],
                                1:this.monthCostAndVariance[i].monthCostAndVariance[1],
                                2:this.monthCostAndVariance[i].monthCostAndVariance[2],
                                3:this.monthCostAndVariance[i].monthCostAndVariance[3]
                            });
                        }
                    }
                })
            },
            // 标签两月对比 详情
            tagTwoMonthVarianceDetails:function(){
                var tagTwoMonthVarianceDetailsDTO={};
                this.varianceColumns=[];
                this.varianceDate=[];
                if(getCookie(global.companyId)!=1){
                    tagTwoMonthVarianceDetailsDTO.companyId='';
                    tagTwoMonthVarianceDetailsDTO.accountIds=[];
                }else {
                    tagTwoMonthVarianceDetailsDTO.companyId=this.companyIds;
                    tagTwoMonthVarianceDetailsDTO.accountIds=this.accountSearchKey;
                }
                this.$api.silverliningEBilling.tagTwoMonthVarianceDetails(tagTwoMonthVarianceDetailsDTO)
                .then(res => {
                    if(res.data.varianceColumns==undefined||res.data.children==undefined){
                        return;
                    }
                    this.varianceColumns=res.data.varianceColumns;
                    this.varianceDate=res.data.children;
                })
              SLBillingPageVue.init();
            },
            /********************************************/
            // Top 15资源类别
            to15ResourceCategories:function(){
                this.resourceType=[];
                this.$api.silverliningEBilling.to15ResourceCategories({
                    "companyId":getCookie(global.companyId)==1? this.companyIds:getCookie(global.companyId),
                    "accountIds":this.accountSearchKey
                })
                .then(res => {
                    // 账单金额
                    if(res.data.overviewBill==undefined){
                        return;
                    }
                    this.resourceType=res.data.overviewBill;
                    SLBillingPageVue.init();
                })
            },
            /********************************************/
            // Top 5 Billing by Tag&Top 3 Variance
            toCompare:function(){
                this.top5Tag=[];
                this.top5TagCost=[];
                this.top3Tag=[];
                this.top3TagPositiveNumber=[];
                this.top3TagNegativeNumber=[];
                this.$api.silverliningEBilling.toCompare({
                    "name":this.billingVarianceTag,
                    "companyId":getCookie(global.companyId)==1? this.companyIds:getCookie(global.companyId),
                    "accountIds":this.accountSearchKey
                })
                .then(res => {
                    if(res.data.top5Tag==undefined||res.data.top5TagCost==undefined||res.data.top3Tag==undefined||res.data.top3TagPositiveNumber==undefined||res.data.top3TagNegativeNumber==undefined){
                        return;
                    }
                    this.top5Tag=res.data.top5Tag;
                    this.top5TagCost=res.data.top5TagCost;
                    this.top3Tag=res.data.top3Tag;
                    this.top3TagPositiveNumber=res.data.top3TagPositiveNumber;
                    this.top3TagNegativeNumber=res.data.top3TagNegativeNumber;
                    SLBillingPageVue.init();
                })
            },
            // 切换
            billingVarianceTagChange:function(){
                SLBillingPageVue.toCompare();
            },
            /******************图表*******************************************************/
            // 柱状图
            barLine:function(){
                this.chartBars=this.$echarts.init(document.getElementById("bar"));
                this.chartBars.setOption({
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        },
                        formatter:function(params)
                        {
                           var relVal = params[0].name;
                           // for (var i = 0, l = params.length; i < l; i++) {
                           //      relVal +='<br/>' + params[i].marker+params[i].seriesName + ' : ' + params[i].value.toLocaleString()+"K";
                           //  }
                           // return relVal;
                           // 鼠标悬浮只显示一个参数
                           return relVal +='<br/>' + params[0].marker+params[0].seriesName + ' : ' + params[0].value.toLocaleString()+"K";
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '3%',
                        bottom: '0%',
                        top:'10%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: this.dateTen,
                            axisPointer: {
                                type: 'shadow'
                            }
                        }
                    ],
                    yAxis:
                    {
                        type: 'value',
                        splitLine: {show: false}

                    },
                    series: [
                        {
                            name:this.$t('Bill.SLBilling.billAmount'),
                            type:'bar',
                            data:this.recentOctoberBill,
                            color: ['#87CEFA'],
                            barWidth: '65%',
                            label: {
                                normal: {
                                    color:'#000',
                                    show: true,
                                    position: 'inside',
                                    "formatter": function(a){return a.value.toLocaleString()+'k'}
                                }
                            }
                        },
                        {
                            name:this.$t('Bill.SLBilling.billAmount'),
                            type:'line',
                            data:this.recentOctoberBill,
                            itemStyle:{
                                normal:{
                                    lineStyle:{
                                        type:'dotted'  //'dotted'虚线 'solid'实线
                                    }
                                }
                            },        
                            label: {
                                normal: {
                                    color:'#000',
                                    show: true,
                                    position: 'top',
                                    "formatter": function(a){return a.value.toLocaleString()+'k'}
                                }
                            }
                        }
                    ]
                })
            },
            // Billing Overview
            pieBillingOverviewLine:function(){
                this.chartPieBillingOverview=this.$echarts.init(document.getElementById("pieBillingOverview"));
                this.chartPieBillingOverview.setOption({
                    tooltip : {
                        trigger: 'item'
                    },
                    legend: {
                        type: 'scroll',
                        top: 10,
                        bottom: 20,
                        orient: 'vertical',
                        left: 'left',
                        data: this.newOverviewBillsList,
                        selected: this.selected,
                        formatter: function(value) {
                            if (value.length > 8) {
                              return value.substring(0, 8) + "...";
                            } else {
                              return value;
                            }
                        }
                    },
                    color:['#47bac1','#e5c55f','#798ee1','#ccc','#008B8B', '#D2691E','#FFA07A','#DAA520','#708090','#FFB6C1','#800080','#6A5ACD','#808000'],
                    series : [
                        {
                            name: this.$t('Bill.SLBilling.billAmount'),
                            type: 'pie',
                            radius : '78%',
                            center: ['50%', '45%'],
                            data:this.overviewBills,
                            labelLine:{
                                normal:{
                                    length:1
                                }
                            },
                            label:{
                                normal:{
                                    formatter(v) {
                                        let text = v.name
                                        return text.length < 4
                                            ? text
                                            : text.substring(0, 8) + "..."
                                    }
                                }
                            },
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                })
            },
             // Top 5 Billing by Tag
            barBillingLine:function(){
                this.chartBarBilling=this.$echarts.init(document.getElementById("barBilling"));
                this.chartBarBilling.setOption({
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        formatter:function(params)
                        {
                           var relVal = params[0].name;
                           for (var i = 0, l = params.length; i < l; i++) {
                                if(params[i].value==0){
                                    relVal += '<br/>' + params[i].seriesName + ' : ' + params[i].value;
                                }else{
                                    relVal += '<br/>' + params[i].seriesName + ' : ' + params[i].value+"K";
                                }
                            }
                           return relVal;
                        }
                    },
                    grid: {
                        top:'10%',
                        left: '3%',
                        right: '10%',
                        bottom: '20%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        data: [0, 0.01]
                    },
                    yAxis: {
                        type: 'category',
                        data: this.top5Tag,
                        axisLabel: {
                            color: "#000",
                            interval: 0,
                            formatter: function(value) {
                                if (value.length > 8) {
                                  return value.substring(0, 8) + "...";
                                } else {
                                  return value;
                                }
                            }
                        }
                    },
                    series: [
                        {
                            name: this.$t('Bill.SLBilling.billAmount'),
                            type: 'bar',
                            barWidth: '40%',
                            data: this.top5TagCost,
                            itemStyle: {
                                normal: {
                                    color: "#2f4554",
                                    lineStyle: {
                                        color: "#2f4554"
                                    }
                                }
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: 'inside',
                                    formatter: function (param) {
                                        return param.value==0 ? param.value:param.value+'k';
                                    }
                                }
                            }
                        }
                    ]
                })
            },
            // Top 3 Variance
            barVarianceLine:function(){
                this.chartbarVariance=this.$echarts.init(document.getElementById("barVariance"));
                this.chartbarVariance.setOption({
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        formatter:function(params)
                        {
                           var relVal = params[0].name;
                           for (var i = 0, l = params.length; i < l; i++) {
                                if(params[i].value!=''){
                                    if(params[i].value==0){
                                        return relVal += '<br/>' + params[i].seriesName + ' : ' + params[i].value;
                                    }else{
                                        return relVal += '<br/>' + params[i].seriesName + ' : ' + params[i].value+"K";
                                    }
                                }
                            }
                        }
                    },
                    grid: {
                        top:'10%',
                        left: '3%',
                        right: '10%',
                        bottom: '20%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'value'
                        }
                    ],
                    yAxis : [
                        {
                            type : 'category',
                            axisTick : {show: false},
                            data : this.top3Tag,
                            axisLabel: {
                                color: "#000",
                                interval: 0,
                                formatter: function(value) {
                                    if (value.length > 8) {
                                      return value.substring(0, 8) + "...";
                                    } else {
                                      return value;
                                    }
                                }
                            }
                        }
                    ],
                    series : [
                        {
                            name:this.$t('Bill.SLBilling.billAmount'),
                            type:'bar',
                            stack: this.$t('Bill.SLBilling.total'),
                            itemStyle: {
                                normal: {
                                    color: "#4682B4",
                                    lineStyle: {
                                        color: "#4682B4"
                                    }
                                }
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: 'inside',
                                    formatter: function (param) {
                                        return Math.abs(param.value)==0 ? Math.abs(param.value):Math.abs(param.value)+'k';
                                    }
                                }
                            },
                            data:this.top3TagNegativeNumber
                        },
                        {
                            name:this.$t('Bill.SLBilling.billAmount'),
                            type:'bar',
                            stack: this.$t('Bill.SLBilling.total'),
                            itemStyle: {
                                normal: {
                                    color: "#FF7F50",
                                    lineStyle: {
                                        color: "#FF7F50"
                                    }
                                }
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: 'inside',
                                    formatter: function (param) {
                                        return param.value==0 ? param.value:param.value+'k';
                                    }
                                }
                            },
                            data:this.top3TagPositiveNumber
                        }
                    ]
                })
            },
            // Top 15 资源类别
            barResourceLine:function(){
                this.chartResource=this.$echarts.init(document.getElementById("barResource"));
                this.chartResource.setOption({
                    color:['#008B8B', '#D2691E','#FFA07A','#DAA520','#708090','#FFB6C1','#800080','#6A5ACD','#00BFFF','#808000'],
                    tooltip : {
                        trigger: 'item',
                        "formatter": function(a){
                            return a.seriesName+'<br/>'+a.name+':'+a.value.toLocaleString()
                        }
                    },

                    calculable : false,
                    series : [
                        {
                            name:this.$t('Bill.SLBilling.Histogram'),
                            type:'treemap',
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: true,
                                        formatter: "{b}"
                                    },
                                    borderWidth: 1
                                },
                                emphasis: {
                                    label: {
                                        show: true
                                    }
                                }
                            },
                            data:this.resourceType
                        }
                    ]
                })
            }
        }
    }
</script>

<style scoped>
    .BillingPage-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .BillingPage-main
    {
        top:127px;
        bottom:16px;
        left:268px;
        right: 10px;
        position: absolute;
    }
    .ivu-col-span-12
    {
        margin-bottom: 20px;
    }
    .ivu-col-span-24
    {
        margin-bottom: 20px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
    }
    .title
    {
        font-size:13px;
        font-weight: 600;
        float:left;
        color:#000;
        margin-bottom: 0px;
    }
    /* 滚动条 */
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #ccc;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
        background: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
        background-color: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowX{
        overflow-x: hidden !important;
    }
</style>




// WEBPACK FOOTER //
// src/components/ebilling/sl_billing_page/SlBillingPage.vue